import { gql } from 'graphql-tag';

export const ANALYTICS_ECCOMERCE_FRAGMENT = gql`
    fragment ANALYTICS_ECCOMERCE_FRAGMENT on AnalyticsEcommerce {
        currencyCode
        impressions {
            id
            list
            position
            variant
        }
    }
`;
